import flightTheme from './flightTheme';

export { flightTheme };

export default flightTheme;
